import { render, staticRenderFns } from "./financeiro-tabela-regras-teto.vue?vue&type=template&id=ba63e7dc"
import script from "./financeiro-tabela-regras-teto.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-regras-teto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports